// extracted by mini-css-extract-plugin
module.exports = {"main":"Signin_main__1QR1u","login":"Signin_login__1Hyeh","formInput":"Signin_formInput__1cg5r","checkbox":"Signin_checkbox__m3OSX","password":"Signin_password__Cy_bt"};